import { Box, Paper, Typography } from '@mui/material';

export function MetricCard({ icon, label, value, subtitle, color = 'primary.main' }) {
  return (
    <Paper
      sx={{
        p: { xs: 2, sm: 2.5 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color }}>
        {icon}
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography variant="h4" component="p" sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
}
